import './form';
import pictoHome from '/images/home-marker.svg';

/**
 * Javacsript utilisé pour la page de recherche des offres d'emploi  
 * url utilisée ex:
 *   /offres-emploi/
 *   /offres-emploi/2
 *   /offres-emploi/paris-75015/
 *   /offres-emploi/paris-75015/2
 */

 (function(w) {
    w.Kinougarde = Object.assign({},w.Kinougarde, { OffresEmploi : {}});
    
    /**
     * Initialisation 
     */
    w.Kinougarde.OffresEmploi.initialisation = function() { 
        
        var self = this;
        this.pageindex = $("#section-offres-emploi").data("filtre-page");
        this.pagesize = 20;
        this.title = document.title;
        this.filtre = {};
        this.markers = null;

        var defautlValue = Kinougarde.GetStorage("form-recherche-offres");

        if (new RegExp(/offres-emploi\/[^\/]+-\d{5}\/?/).test(document.location.pathname)) {
             // Nous somme une une page du type /offre-emploi/paris-75019/   
            // Le resultat a été chargé coté serveur pas besoin de faire d'ajax de recherche                         
            Kinougarde.OffresEmploi.ResetFilter();
            this.filtre = { adresse : $("[data-filtre-geocode]").data("filtre-geocode"),                           
                           adresse_lat :  jQuery("[data-filtre-latitude]").data("filtre-latitude"),
                           adresse_lng :  jQuery("[data-filtre-longitude]").data("filtre-longitude"),
                           adresse_postal_code :  jQuery("[data-filtre-codepostal]").data("filtre-codepostal"),
                           adresse_locality :  jQuery("[data-filtre-ville]").data("filtre-ville")
                        };
            Kinougarde.GetAgency(jQuery("[data-filtre-agence]").data("filtre-agence")).then(function(agence) {
                // Mise à jour de la variable globale            
                Kinougarde.UpdateAgence(agence);                
            });    
            Kinougarde.TagManagerTunnel('Offres/step-1');   
            Kinougarde.TagManagerTunnel('Offres/step-1',{event : (jQuery("#section-offres-emploi-list>div").length>0 ? 'DisplayOfferListFull': 'DisplayOfferListEmpty')});
                        
        }                
        // Paramètre de recherche dans le  localstorage
        else if (defautlValue!==null) {                        
            //var pageindex = typeof(defautlValue.pageindex)!=='undefined' ?defautlValue.pageindex :  this.pageindex;
            this.filtre = defautlValue;
            Kinougarde.OffresEmploi.ResetFilter();
            this.Rechercher(this.pagesize , this.pageindex, this.filtre,false);
        } 
        else {
            // Page /offres-emploi/ sans recherche préalable
            Kinougarde.TagManagerTunnel('Offres/step-1');   
            Kinougarde.TagManagerTunnel('Offres/step-1',{event : 'DisplayOfferListFull'});            
        }
        
        // Capte l'évènement recherche-offres envoyé par le flexible content recherche-offre (click sur le bouton "Trouver")
        $(document).on('recherche-offres', function(e,data) {
            // Repositionne sur la liste                        
            $("#section-offres-emploi label[for=real-tab1]").trigger('click');
            // Reinitialise le filtre
            Kinougarde.OffresEmploi.ResetFilter();
            //Ferme le panneau filtre
            if ($("#real-tab3").prop("checked"))  $("#section-offres-emploi label[for=real-tab3]").trigger('click');
            Kinougarde.OffresEmploi.Rechercher(self.pagesize, 1, data);  
        })
        //Capte le click sur "Afficher les résultats"
        $("#section-offres-emploi-filtre-btn").on('click',function(e) {
            e.preventDefault();
            self.formFiltre = $("#section-offres-emploi-filtre-form").parsley();
            self.formFiltre.validate();
            if (self.formFiltre.isValid()) { 
                //Ferme le panneau filtre
                if ($("#real-tab3").prop("checked"))  $("#section-offres-emploi label[for=real-tab3]").trigger('click');
                // Repositionne sur la liste                        
                $("#section-offres-emploi label[for=real-tab1]").trigger('click');
                // Recupère toutes les valeurs des champs du formulaire pour les stocker dans filtre
                var trackingfiltre = {event : 'FilterResult',MasquerLesOffresAvecVehicule : false, NbEnfantsMax : null};
                $("#section-offres-emploi-filtre-form").serializeArray().forEach(function(value, key){
                    self.filtre[value['name']]= (typeof(value['value'])!==undefined && value['value']!=="" ? value['value'] : null);
                    trackingfiltre = Object.assign(trackingfiltre, {[value['name']] : (typeof(value['value'])!==undefined && value['value']!=="" ? value['value'] : null) });
                    //trackingfiltre[value['name']] = (typeof(value['value'])!==undefined && value['value']!=="" ? value['value'] : null);
                });                  
                //console.debug('dataLayer.push: ' + JSON.stringify(trackingfiltre));     
                dataLayer.push(trackingfiltre);           
                w.Kinougarde.OffresEmploi.Rechercher(self.pagesize, 1, self.filtre,true);  
            }
        });
        // Capte le click sur "Supprimer les filtres"
        $("#section-offres-emploi-filtre-reset").on('click',function(e) {
            e.preventDefault();
            Kinougarde.OffresEmploi.ResetFilter();            
        })
        // Capte le click sur "Carte"
        $("#section-offres-emploi label[for=real-tab2]").on('click',function(e) {
            //e.preventDefault();
            w.Kinougarde.OffresEmploi.RechercherCarte(self.filtre);
        });


        // Repositionne sur la liste                        
        $("#section-offres-emploi label[for=real-tab1]").trigger('click');
         
        // Du fait que les boutons suivant et précédent sont recréé à chaque recherche
         // la ligne ci-dessous n'est utile que lors d'une pagination sans recherche préalable sur /offres-emploi/
        this.Pagination();
        this.ActualiseDejaVuesPostule();
        
    }

    /**
     * Gestion de la pagination
     */
    w.Kinougarde.OffresEmploi.Pagination = function() {
        var self = this;
        var match = document.location.pathname.match(/(\/offres-emploi(\/[^\/]+-\d{5})?\/)(\d+\/?)?/);
        var urlNext = match[1] + (self.pageindex + 1) +'/';
        var urlPrev = match[1] + (self.pageindex - 1) +'/';
        if (self.pageindex===2) {
            urlPrev = match[1];
        }
                
        // Click sur le bouton de pagination "Suivant"          
         $("#recherche-offres-emploi-btn-suivant").on('click',function() {            
            w.Kinougarde.OffresEmploi.Rechercher(self.pagesize, self.pageindex + 1,self.filtre, true);
            if (self.pageindex>1) {
                document.title = self.title + " | Page " + self.pageindex;
            }
            history.pushState({url : document.location.pathname , next : urlNext , pageIndexNext : self.pageindex }, null,urlNext)            
        });
        // Click sur le bouton de pagination "Précédent"
        $("#recherche-offres-emploi-btn-precedent").on('click',function() {            
            w.Kinougarde.OffresEmploi.Rechercher(self.pagesize, self.pageindex -1, self.filtre, true);
            if (self.pageindex>1) {
                document.title = self.title + " | Page " + self.pageindex;
            } else {
                document.title = self.title;
            }
            history.pushState({url : document.location.pathname , next : urlPrev , pageIndexNext : self.pageindex }, null,urlPrev);            
        }); 
    }

    /**
     * Actualise la liste des offres déjà vue ou déjà postulées
     */
    w.Kinougarde.OffresEmploi.ActualiseDejaVuesPostule = function() {
         //Gestion des offres déja vues 
         var offresDejaVues = Kinougarde.GetStorage("offres-emploi-vues");
         if (typeof(offresDejaVues)!=='undefined' && offresDejaVues!==null) {
             offresDejaVues.forEach( id => {
                 $("#offre-"+ id).addClass('deja-vue');
             });
         }
         // Gestion des offres déjà postulées
         var offresDejaPostulee = Kinougarde.GetStorage("offres-emploi-postulees");
         if (typeof(offresDejaPostulee)!=='undefined' && offresDejaPostulee!==null) {
             offresDejaPostulee.forEach( id => {
                 $("#offre-"+ id).removeClass('deja-vue');
                 $("#offre-"+ id).addClass('deja-postule');
             });
         }
    }

    /**
     * Recherche des offres (mode liste) 
     */
    w.Kinougarde.OffresEmploi.Rechercher = function(pagesize,pageindex,filtre,scrollTop=false) {  
        var self = this;
        this.pageindex = pageindex;
        this.filtre = filtre;
        this.map = null;        
        this.SetFilterCount();

        let data = Object.assign( {action : 'ajax_offres_emploi', pagesize : pagesize , pageindex : pageindex}, filtre);
                
        // Gestion des candidatures déjà postulé
        var postuler = Kinougarde.GetStorage("form-postuler");
        if (typeof(postuler)!=='undefined' && postuler!==null) {
            try {
            data.ti = postuler.id
            }
            catch (e) {}
        }

        this.ShowAjaxLoader(true);

        this.ajaxEnCours =  $.ajax({
            type     : 'POST',
            dataType : 'json',
            url      : ajax_kinougarde_object.ajaxurl,
            data     : data,
            success  : function (reponse) {               
               self.ShowAjaxLoader(false);    
               if (scrollTop===true) {
                $('html').animate({scrollTop: 0}, 100);
               }
               $("#section-offres-emploi-list").html(reponse.data.HtmlListeOffres);
               
                // Mémorise la recherche
                Kinougarde.SetStorage("form-recherche-offres",filtre)

               if (reponse.data.IdAgence!=null) {
               w.Kinougarde.GetAgency(reponse.data.IdAgence).then(function(agence) {
                    // Mise à jour de la variable globale            
                    Kinougarde.UpdateAgence(agence);                
                });        
               }

                if (reponse.data.NbOffres>0) {
                    self.Pagination();  
                    self.ActualiseDejaVuesPostule(); 
                    Kinougarde.TagManagerTunnel('Offres/step-1');                 
                    Kinougarde.TagManagerTunnel('Offres/step-1',{event : 'DisplayOfferListFull'});                 
                } else {
                    Kinougarde.TagManagerTunnel('Offres/step-1',{event : 'DisplayOfferListEmpty'});
                }
                var masquerLaCarte = reponse.data.NbOffres<=0 || typeof(filtre.adresse_lat)==='undefined' || typeof(filtre.adresse_lng)==='undefined' ||  filtre.adresse_lat===null || filtre.adresse_lng==null;
                if (masquerLaCarte===true) {
                    $("label[for=real-tab2]").addClass("hidden");
                } else {
                    $("label[for=real-tab2]").removeClass("hidden");
                }
                
            },                    
            error: function (reponse) {
                // Affichage d'un message d'erreur  
                self.ShowAjaxLoader(false);  
                $("#section-offres-emploi-list").html(Kinougarde.Form.getMessageErrorAjax());                                                                      
            }
        });  
    } 
    
    
    /**
    * Recherche des offres (mode carte) 
    */
    w.Kinougarde.OffresEmploi.RechercherCarte = function(filtre) { 
        
        
        var self = this;        
        if (typeof(this.map)==='undefined' || this.map==null) {
            
            $("#map").addClass("loading-state");
            //La carte n'a pas encore été chargée
            this.filtre = filtre;    
            var data = Object.assign(filtre, {action : 'ajax_offres_emploi_carte'});
            
            this.ajaxEnCours =  $.ajax({
                type     : 'POST',
                dataType : 'json',
                url      : ajax_kinougarde_object.ajaxurl,
                data     : data,
                success  : function (reponse) {
                    $("#map").removeClass("loading-state");
                    w.Kinougarde.OffresEmploi.AfficherCarte(parseFloat(data.adresse_lat),parseFloat(data.adresse_lng),reponse.data.Offres);                              
                },                    
                error: function (reponse) {
                    // Affichage d'un message d'erreur                 
                    $("#map").removeClass("loading-state");
                    $("#section-offres-emploi-map").html(Kinougarde.Form.getMessageErrorAjax());                                                                      
                }
            });  
        } else {
            // La carte a déjà été chargée
        }
    }


    /**
     * Affichage de la carte
     */
    w.Kinougarde.OffresEmploi.AfficherCarte = function(latitude,longitude,offres) {
        var self = this;
        googleMapsLoadedPromise.then(function() {

            self.icon = {path: "m 29.7 90 c 1.35 0 2.61 -0.6 3.51 -1.6 c 0.27 -0.3 6.57 -7.5 12.87 -17.6 c 8.82 -14.1 13.32 -26.5 13.32 -37 c 0 -18.7 -13.32 -33.8 -29.7 -33.8 s -29.7 15.1 -29.7 33.8 c 0 10.5 4.5 23 13.32 37 c 6.39 10.1 12.6 17.3 12.87 17.6 c 0.9 1 2.16 1.6 3.51 1.6 z m -12.69 -59.5 c 0 -8 5.67 -14.5 12.69 -14.5 s 12.69 6.5 12.69 14.5 s -5.67 14.5 -12.69 14.5 s -12.69 -6.5 -12.69 -14.5 z",
                fillColor     : '#D1007F',
                fillOpacity   : 1,
                strokeWeight  : 0,
                strokeOpacity : 1,
                scale         : 0.35,                  
                anchor:  new google.maps.Point(0,0)};          
            self.iconHome = {
                url: pictoHome,  
                fillColor     : '#0000',
                fillOpacity   : 1,
                strokeWeight  : 0,
                strokeOpacity : 1,                
                scaledSize    :  new google.maps.Size(30,40),            
                pixelOffset: new google.maps.Size(0,0),
            }; 

            self.iconInactif = {path: "m 29.7 90 c 1.35 0 2.61 -0.6 3.51 -1.6 c 0.27 -0.3 6.57 -7.5 12.87 -17.6 c 8.82 -14.1 13.32 -26.5 13.32 -37 c 0 -18.7 -13.32 -33.8 -29.7 -33.8 s -29.7 15.1 -29.7 33.8 c 0 10.5 4.5 23 13.32 37 c 6.39 10.1 12.6 17.3 12.87 17.6 c 0.9 1 2.16 1.6 3.51 1.6 z m -12.69 -59.5 c 0 -8 5.67 -14.5 12.69 -14.5 s 12.69 6.5 12.69 14.5 s -5.67 14.5 -12.69 14.5 s -12.69 -6.5 -12.69 -14.5 z",
                fillColor     : '#D3AFBE',
                fillOpacity   : 1,
                strokeWeight  : 0,
                strokeOpacity : 1,
                scale         : 0.30,            
                anchor:  new google.maps.Point(0,0)}; 
            const kinougardeMapStyle =
                [ { "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [ { "color": "#444444" } ] }, { "featureType": "landscape", "stylers": [ { "color": "#f2f2f2" } ] }, { "featureType": "poi", "stylers": [ { "visibility": "off" } ] }, { "featureType": "road", "stylers": [ { "saturation": -100 }, { "lightness": 45 } ] }, { "featureType": "road.arterial", "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "road.highway", "stylers": [ { "visibility": "simplified" } ] }, { "featureType": "transit", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit.station", "stylers": [ { "visibility": "on" } ] }, { "featureType": "transit.station.bus", "stylers": [ { "visibility": "off" } ] }, { "featureType": "water", "stylers": [ { "color": "#aad2e3" }, { "visibility": "on" } ] } ];

            self.map = new google.maps.Map(document.getElementById("map"), {
                center: { lat: latitude, lng: longitude },
                zoom: 14,
                styles : kinougardeMapStyle,  
                streetViewControl : false,              
            });  

            // Ajout du marker home
            new google.maps.Marker({ map : self.map,
                position : { lat: latitude, lng : longitude},
                IdKinougarde : 0,                
                icon: self.iconHome,
                optimized: false  // false pour les tests automatisés selenium                   
            }); 

            var bounds = new google.maps.LatLngBounds({ lat: latitude, lng : longitude});

            //Ajout des markers
            self.markers = offres.map((offre,i) => {                                        
                var marker = new google.maps.Marker({ map : self.map,
                    position : { lat: offre.Latitude, lng : offre.Longitude},
                    IdKinougarde : offre.IdDemande,
                    offre : offre,
                    icon: self.icon ,
                    optimized: false  // false pour les tests automatisés selenium                      
                }); 
                bounds.extend({ lat: offre.Latitude, lng : offre.Longitude});
                marker.addListener("click", (m)=> {    
                    self.SelectMarker(marker);
                });                
                return marker;           
            }); 
            self.map.fitBounds(bounds);                       
        });        
    }

    /**
     * Selection d'un marker sur la carte
     * @param {Selectionne } marker 
     */     
    w.Kinougarde.OffresEmploi.SelectMarker = function(marker) {
        var self =this;
        if (marker!==null) {
            // Affiche l'info box                    
            $("#infobox-offre").html(this.GetHtmlInfoBox(marker.offre)); 
            $("#infobox-offre").removeClass("hidden");
            // Fermeture de l'infobox
            $("#infobox-offre button.close").on('click', function() {
                $("#infobox-offre").addClass("hidden");
                self.markers.forEach(m => {
                    if (m.IdKinougarde!==0) {
                        m.setIcon(self.icon);
                    }
                });
            });  
            //change l'icone à inactif pour tout les autres picto
            this.markers.forEach(m => {
                if (m.IdKinougarde!==0) {
                    m.setIcon(self.iconInactif);
                }
            });
            marker.setIcon(this.icon);
        } else {
            // pas de marker on réactive tous les icons            
            this.markers.forEach(m => {
                if (m.IdKinougarde!==0) {
                    m.setIcon(self.icon);
                }
            });
        }
    }

    /**
     * Retourne le code Html d'une infos box d'une offre
     * @param {} marker 
     */
    w.Kinougarde.OffresEmploi.GetHtmlInfoBox = function(offre) {

        
        var html ='<div class="header"><button type="button" class="close">&nbsp;</button>';        
        html += '<div class="row">';
        html += '<p class="ref">ref. ' + offre.IdDemande + '</p>';
        html += '<p class="distance">À ' + offre.Distance + ' km</p>';
        html += '<p class="place">'+ offre.Ville.toLowerCase() +'</p>';
        if (offre.VehiculeObligatoire===true) {
            html +='<p class="text-center"><span class="has-vehicle">Véhiculé</span></p>';
        }
        html += '<p class="hours">'+offre.NbHeureHebdomadaire +' heures / semaine</p>';     
        html += '<p class="schedule">A partir du ' + new Date(offre.DateDebut).toLocaleDateString('fr') +'</p>';
        html += '<p class="kids">'+ offre.LibelleEnfants +'</p>';
        html +='</div></div>';
        html +='<footer>';
        html += '<p class="price orange">'+offre.SalaireBrutEuro+' € brut/h</p>'
        html += '<div class="text-center"><a href="'+ offre.UrlOffre+ '" class="button green">Voir l\'offre</a></div>';
        html +='</footer>';
        return html;
        
    }
    

    /**
     * Affiche ou masque le loader pendant la recherche
     * @param {} show 
     */
    w.Kinougarde.OffresEmploi.ShowAjaxLoader = function(show) {
        if(show===true) {
            $("#section-offres-emploi-list").addClass("loading-state");        
        } else {
            $("#section-offres-emploi-list").removeClass("loading-state");        
        }        
    }

    /**
     * Actualise le nombre de filtre selectionné
     */
    w.Kinougarde.OffresEmploi.SetFilterCount = function() {
        
        var nbfiltre = 0;
        if ((typeof(this.filtre.NbHeureMin)!==undefined && this.filtre.NbHeureMin!=null) ||
            (typeof(this.filtre.NbHeureMax)!==undefined && this.filtre.NbHeureMax!=null)) nbfiltre++;
        if (typeof(this.filtre.NbEnfantsMax)!==undefined && this.filtre.NbEnfantsMax!=null)  nbfiltre++;
        if ((typeof(this.filtre.AgeMin)!==undefined && this.filtre.AgeMin!=null) ||
            (typeof(this.filtre.AgeMax)!==undefined && this.filtre.AgeMax!=null)) nbfiltre++;
        if (typeof(this.filtre.MasquerLesOffresAvecVehicule)!==undefined && this.filtre.MasquerLesOffresAvecVehicule!=null) nbfiltre++
        
        var $filterCountContainer = $('#filtersCount');
        var $filterCountOutput = $filterCountContainer.find('output');
        if (nbfiltre===0) {
            $filterCountContainer.addClass('hidden')
        } else {
            $filterCountContainer.removeClass('hidden')
        }
        $filterCountOutput.text(nbfiltre)
    }

    /**
     * Réinitilise les valeur par défaut du filtre
     */
    w.Kinougarde.OffresEmploi.ResetFilter = function() {
        $("#min_hours").val("");
        $("#max_hours").val("");
        $("#enfants1").prop("checked",false);
        $("#enfants2").prop("checked",false);
        $("#enfants3").prop("checked",false);
        $("#enfants4").prop("checked",false);
        $("#min_age").val("");
        $("#max_age").val("");
        $("#vehicle").prop("checked",false);
        this.filtre.AgeMin=null;
        this.filtre.AgeMax=null;
        this.filtre.MasquerLesOffresAvecVehicule = null;
        this.filtre.NbHeureMin = null;
        this.filtre.NbHeureMax = null;
        this.filtre.NbEnfantsMax = null;
        Kinougarde.OffresEmploi.SetFilterCount();
    }
    
    
    // Gestion du back navigateur
    w.onpopstate =function(event) {				
        if (event.state!==null) {                 
            //console.debug(event.state);
            var pageindex = 1
            if (typeof(event.state.pageIndexNext)!=='undefined') {
                pageindex = event.state.pageIndexNext;
            }
            Kinougarde.OffresEmploi.Rechercher(Kinougarde.OffresEmploi.pagesize , pageindex, Kinougarde.OffresEmploi.filtre,false);
        }
    }

    // Gestion du back avec Safari (permet de réexcuter le code js sur un back)
    w.onpageshow = function(event) {
		if (event.persisted) {
			Kinougarde.OffresEmploi.ActualiseDejaVuesPostule();
		}
	};

})(window);


jQuery(function() {
    try {        
        // Bloc de recherche des offres
        if (jQuery("#section-offres-emploi").length>0) {
            Kinougarde.OffresEmploi.initialisation();
        }        
    }     
    catch (ex) {
        console.error(ex);
    }
});